var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOnOffCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM13 6.50002C13 5.94774 12.5523 5.50002 12 5.50002C11.4477 5.50002 11 5.94774 11 6.50002V8.75928C11 9.31156 11.4477 9.75928 12 9.75928C12.5523 9.75928 13 9.31156 13 8.75928V6.50002ZM9.29544 9.24595C9.70741 8.87812 9.74319 8.24597 9.37535 7.834C9.00752 7.42203 8.37536 7.38626 7.9634 7.75409C6.7617 8.82706 6 10.3802 6 12.1111C6 15.3845 8.7076 18 12 18C15.2924 18 18 15.3845 18 12.1111C18 10.3802 17.2383 8.82706 16.0366 7.75409C15.6246 7.38626 14.9925 7.42203 14.6246 7.834C14.2568 8.24597 14.2926 8.87812 14.7046 9.24595C15.5054 9.96101 16 10.9815 16 12.1111C16 14.2378 14.2304 16 12 16C9.76956 16 8 14.2378 8 12.1111C8 10.9815 8.4946 9.96101 9.29544 9.24595Z",
    fill: "#181A1B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnOffCircle);
export default __webpack_public_path__ + "static/media/onOffCircle.eea35f694bfe8835b911d5d9670d4113.svg";
export { ForwardRef as ReactComponent };